import { Button, Stack } from "@mui/material";
import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";
import { WorkflowConfiguration } from "../../../Pages/admin/Settings/SettingsDiagramDesigner/node-configuration-panel";
import { useSelector } from "react-redux";
import { GetWorkflow } from "../../../Redux/Reducers/redux-slice-workflow-designer";

export type ModalSaveDiagramDesignerElementProps = {
  onConfirm?: () => void;
};

export type ModalSaveDiagramDesignerProps = CommonModalProps<ModalSaveDiagramDesignerElementProps>;

const ModalSaveDiagramDesigner = forwardRef<any, ModalSaveDiagramDesignerProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onConfirm } = props;

  const workflow = useSelector(GetWorkflow);
  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      title={"Save Workflow as..."}
      reference={ref}
      closeModal={handleCancelClick}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button
            color="success"
            variant="outlined"
            onClick={() => {
              onConfirm && onConfirm();
              closeModal();
            }}
            disabled={!workflow.name || workflow.name.length < 2}
          >
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={1}>
        <WorkflowConfiguration />
      </Stack>
    </Modal>
  );
});
export default ModalSaveDiagramDesigner;
